/* Hannemann – Warenkorb-Helfer (Sept 2026)
   „Warenkorb leeren“ mit Rückfrage im AMP Slide Cart und auf der Warenkorb-Seite.
   Gestaltung: assets/custom-overrides.css (Abschnitt „Warenkorb“). */
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var TRASH = '<svg aria-hidden="true" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6"/></svg>';

  function clearCart() {
    return fetch(root + 'cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function build(onDone) {
    var w = document.createElement('div');
    w.className = 'hn-clear';
    w.innerHTML =
      '<button type="button" class="hn-clear__link">' + TRASH + '<span>Warenkorb leeren</span></button>' +
      '<span class="hn-clear__confirm" hidden>Alle Artikel entfernen? ' +
      '<button type="button" class="hn-clear__yes">Ja, leeren</button>' +
      '<span class="hn-clear__sep">·</span>' +
      '<button type="button" class="hn-clear__no">Abbrechen</button></span>';
    var link = w.querySelector('.hn-clear__link');
    var confirmBox = w.querySelector('.hn-clear__confirm');
    link.addEventListener('click', function () { link.hidden = true; confirmBox.hidden = false; w.querySelector('.hn-clear__yes').focus(); });
    w.querySelector('.hn-clear__no').addEventListener('click', function () { confirmBox.hidden = true; link.hidden = false; link.focus(); });
    w.querySelector('.hn-clear__yes').addEventListener('click', function () {
      confirmBox.textContent = 'Wird geleert …';
      clearCart().then(onDone).catch(function () { confirmBox.textContent = 'Das hat leider nicht geklappt. Bitte lade die Seite neu.'; });
    });
    return w;
  }

  /* AMP Slide Cart */
  function syncSlideCart() {
    var sc = document.querySelector('#slidecarthq .slidecarthq');
    if (!sc) return;
    // Nachrichtenfeld immer offen anzeigen (statt nur als Link)
    var note = sc.querySelector(':scope > .note');
    if (note && !note.querySelector('.note-body')) {
      var trigger = note.querySelector('.note-trigger');
      if (trigger) trigger.click();
    }
    var items = sc.querySelector(':scope > .items');
    var hasItems = !!(items && items.querySelector('.item'));
    var existing = sc.querySelector(':scope > .hn-clear');
    if (!hasItems) { if (existing) existing.remove(); return; }
    if (existing && existing.previousElementSibling === items) return;
    if (existing) existing.remove();
    items.insertAdjacentElement('afterend', build(function () {
      if (typeof window.SLIDECART_UPDATE === 'function') window.SLIDECART_UPDATE();
      else window.location.reload();
    }));
  }

  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; syncSlideCart(); syncEmptyCart(); refreshEmptyWhenLoaded(); fixDelivery(); fixCustomerCount(); addNavIcons(); patchSlideCart(); addPayIcons(); }, 30);
  }

  /* Produktseite: Lieferzeit-Hinweis einheitlich auf „1–3 Tage“ (wie im Warenkorb und in den FAQ).
     Der Text „In 1-2 Tagen bei dir zuhause“ steht einzeln in den Produktvorlagen; hier wird er zentral angepasst. */
  function fixDelivery() {
    document.querySelectorAll('.lb-delivery-time').forEach(function (el) {
      if (el.dataset.hnFixed) return;
      el.dataset.hnFixed = '1';
      el.innerHTML = el.innerHTML.replace(/1\s*[-–]\s*2 Tag/g, '1–3 Tag');
    });
  }

  /* Kundenzahl („fast 12.000“, Stand Sept 2026: 11.929 Käufer) auf Produkt- und Kollektionsseiten.
     Die alten Texte („11.000+ Personen“ / „über 11.000 begeisterten Kunden“) stehen einzeln in den Vorlagen;
     hier werden genau diese alten Formulierungen ersetzt. Wird der Text im Theme-Editor geändert, greift das hier nicht mehr. */
  function fixCustomerCount() {
    document.querySelectorAll('.lb-liked-from-three-counter, .trust-banner-section').forEach(function (el) {
      if (el.dataset.hnCount) return;
      el.dataset.hnCount = '1';
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
      var n;
      while ((n = walker.nextNode())) {
        n.nodeValue = n.nodeValue
          .replace(/11\.000\+\s*Personen/g, 'Fast 12.000 Personen')
          .replace(/über 11\.000 begeisterten/g, 'fast 12.000 begeisterten');
      }
    });
  }


  /* Menü-Icons (Sept 2026): kleine Icons vor den Hauptkategorien – nur im Handy-Menü (Seitenleiste), nicht im Desktop-Menü.
     Zuordnung über den Link der Kategorie. Neues Icon = neue Zeile mit dem Link (z. B. '/collections/xyz'). */
  var NAV_ICONS = {
    '/collections/neu': { f: false, d: '<path d="M12 3l1.8 4.6L18.5 9l-4.7 1.5L12 15l-1.8-4.5L5.5 9l4.7-1.4z"/><path d="M18.5 15l.8 2 2 .8-2 .8-.8 2-.8-2-2-.8 2-.8z"/>' }, // NEU
    '/collections/routinen': { f: false, d: '<path d="M2.5 6.5h6"/><path d="M3 6.5c0-1.6 1.2-2.5 2.5-2.5S8 4.9 8 6.5"/><path d="M5.5 6.5v14"/><path d="M4.6 10.5h1.8M4.6 12.5h1.8M4.6 14.5h1.8"/><path d="M11 13.5h5.5v6a1 1 0 0 1-1 1H12a1 1 0 0 1-1-1z"/><path d="M10.5 13.5h6.5"/><path d="M19 8h2.5v2.5H19z"/><path d="M18.5 10.5h3.5v9a1 1 0 0 1-1 1h-1.5a1 1 0 0 1-1-1z"/>' }, // Routinen
    '/collections/vor-der-rasur': { f: false, d: '<path d="M4 12h16l-1.5 6.5a2 2 0 0 1-2 1.5h-9a2 2 0 0 1-2-1.5z"/><path d="M6 12c0-2 1.5-3 3-2.5.5-2 3.5-2.5 4.5-.5 1.5-1 4 0 4 3"/>' }, // Vor der Rasur
    '/collections/aftershave-nach-der-rasur': { f: false, d: '<path d="M9 3h6v3H9z"/><path d="M10 6v2.5c-2.5 1-4 2.5-4 5V20a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-6.5c0-2.5-1.5-4-4-5V6"/><path d="M8.5 14h7"/>' }, // Nach der Rasur
    '/collections/rasierwerkzeug': { f: false, d: '<path d="M4 7.2c2-2.4 14-2.4 16 0v1.3H4z"/><path d="M5 8.5h14"/><path d="M6 8.5v1.3M8.5 8.5v1.3M11 8.5v1.3M13.5 8.5v1.3M16 8.5v1.3M18 8.5v1.3"/><path d="M10.5 10v2h3v-2"/><path d="M10.3 12h3.4v8H10.3z"/><path d="M10.3 14h3.4M10.3 16h3.4M10.3 18h3.4"/><path d="M11 20h2l-.3 1.5h-1.4z"/>' }, // Rasierwerkzeug
    '/collections/zubehor': { f: false, d: '<ellipse cx="12" cy="9" rx="9" ry="2.6"/><path d="M3 9c0 5.5 4 9.5 9 9.5s9-4 9-9.5"/><path d="M8.5 18 8 20.5h8l-.5-2.5"/><path d="M6 8.8c1.7.9 3.8 1.3 6 1.3"/>' }, // Zubehör
    '/collections/bartpflege': { f: false, d: '<path d="M5 8c0 7 3 12 7 12s7-5 7-12"/><path d="M5 8c2 2.5 4.5 2 7 .5 2.5 1.5 5 2 7-.5"/><path d="M9.5 14c1.5-.8 3.5-.8 5 0"/>' }, // Bartpflege
    '/collections/duschbrocken': { f: false, d: '<path d="M4.8 7.4 12.6 5 18.6 19.4 10.6 22z"/><path d="M4.8 7.4 8.4 3.6 15.8 2.2 12.6 5"/><path d="M15.8 2.2 20.2 14.6 18.6 19.4"/>' }, // Duschbrocken
    '/collections/haar-und-korperpflege': { f: false, d: '<path d="M5 4h6a4 4 0 0 1 4 4v1"/><path d="M11.5 9h7l-1 2.5h-5z"/><path d="M13 14v1.5M15 14v2.5M17 14v1.5M14 18v1.5M16 18v1.5"/>' }, // Haar & Körper
    '/collections/hannemann-lubeck-eigenmarke': { f: true, d: '<path fill="#263e0f" fill-rule="evenodd" d="M10.30 11.46 L9.97 11.68 L9.97 11.79 L9.40 12.32 L9.40 12.43 L8.92 12.85 L7.60 15.62 L7.42 15.80 L7.25 16.26 L7.18 16.27 L6.90 16.96 L3.83 22.99 L4.27 22.99 L4.73 22.82 L5.21 22.42 L5.26 22.19 L5.37 22.12 L7.52 17.72 L7.93 17.07 L9.95 12.91 L10.25 12.49 L10.25 12.32 L10.37 12.19 L10.37 11.57Z M11.18 4.37 L10.90 4.72 L10.50 5.64 L10.32 5.82 L9.80 6.97 L9.62 7.15 L8.64 9.17 L8.52 9.24 L7.60 11.15 L7.42 11.33 L7.02 12.25 L6.83 12.45 L6.56 13.13 L6.32 13.42 L5.86 14.45 L5.68 14.65 L4.63 16.78 L4.45 16.97 L4.17 17.65 L3.99 17.83 L3.48 18.99 L3.30 19.17 L2.49 20.74 L2.43 21.25 L2.36 21.26 L2.49 22.00 L2.60 22.23 L2.78 22.36 L2.78 22.47 L3.35 22.87 L3.46 22.82 L5.43 18.82 L5.85 18.17 L7.52 14.70 L8.39 13.13 L8.56 12.67 L10.02 11.09 L9.67 10.80 L9.67 10.64 L10.02 10.05 L10.30 9.24 L10.48 9.01 L10.65 8.49 L11.07 7.78 L11.35 6.99 L11.93 5.86 L11.93 5.71 L11.82 5.64Z M12.00 3.09 L11.60 3.38 L11.48 3.62 L11.48 4.12 L12.13 5.18 L12.24 5.51 L12.42 5.71 L12.64 6.28 L13.52 7.91 L13.63 8.31 L14.16 9.30 L14.44 10.16 L14.56 10.29 L15.13 11.96 L15.26 12.10 L15.43 12.78 L15.61 13.07 L15.66 13.48 L16.07 14.53 L16.53 16.37 L16.59 16.39 L17.51 20.55 L17.64 20.67 L17.81 21.13 L18.15 21.50 L18.15 21.59 L19.14 22.42 L20.42 22.87 L21.62 22.87 L21.45 22.30 L20.98 21.43 L20.70 20.62 L20.52 20.38 L20.41 19.98 L20.23 19.74 L20.17 19.46 L19.66 18.46 L19.66 18.31 L19.42 17.95 L19.42 17.78 L19.13 17.31 L19.13 17.14 L18.95 16.90 L18.67 16.09 L18.60 16.08 L18.08 14.81 L17.90 14.58 L17.90 14.41 L17.63 13.94 L17.63 13.77 L17.44 13.53 L17.28 13.02 L17.15 12.89 L17.15 12.72 L16.86 12.25 L16.58 11.46 L16.51 11.44 L16.34 10.93 L15.88 10.05 L15.88 9.88 L15.59 9.41 L15.59 9.24 L15.12 8.37 L14.84 7.56 L14.66 7.32 L14.55 6.92 L14.37 6.68 L14.37 6.51 L13.80 5.40 L13.80 5.25 L13.56 4.88 L13.56 4.72 L13.32 4.36 L13.10 3.67 L12.75 3.21 L12.52 3.09Z M13.38 1.00 L12.93 1.06 L12.70 1.29 L12.06 2.67 L12.75 2.73 L13.21 3.07 L13.85 1.63 L13.73 1.24 L13.56 1.06Z"/>' }, // Hannemann - Eine Eigenmarke
    '/products/geschenkgutschein': { f: false, d: '<path d="M3.5 8.5h17v12h-17z"/><path d="M2.5 5.5h19v3h-19z"/><path d="M12 5.5v15"/><path d="M12 5.5c-1.5-3-5-3-4.5-.5.3 1 2.5.5 4.5.5zM12 5.5c1.5-3 5-3 4.5-.5-.3 1-2.5.5-4.5.5z"/>' }, // Gutschein
    '/collections/sale': { f: false, d: '<path d="M3 12.5V4h8.5L21 13.5 12.5 22z"/><circle cx="7.5" cy="8.5" r="1.3"/><path d="M10.5 16.5l5-5"/>' }, // SALE
  };
  function addNavIcons() {
    if (!document.getElementById('hn-navic-css')) {
      var css = document.createElement('style');
      css.id = 'hn-navic-css';
      css.textContent = '.hn-navic{display:inline-flex;vertical-align:middle;align-items:center;justify-content:center;width:30px;height:30px;flex:0 0 30px;margin-right:8px;border-radius:50%;background:#f4f1ea}.hn-navic svg{display:block;width:19px!important;height:19px!important;max-width:none!important}';
      document.head.appendChild(css);
    }
    document.querySelectorAll('.halo-sidebar_menu a.menu-lv-1__action').forEach(function (a) {
      if (a.querySelector('.hn-navic')) return;
      var path;
      try { path = new URL(a.getAttribute('href'), location.origin).pathname.replace(/\/$/, ''); } catch (e) { return; }
      var ic = NAV_ICONS[path];
      var label = a.querySelector('span.text');
      if (!ic || !label) return;
      var s = document.createElement('span');
      s.className = 'hn-navic';
      s.setAttribute('aria-hidden', 'true');
      s.innerHTML = '<svg viewBox="0 0 24 24" width="19" height="19"' + (ic.f
        ? '><g fill="#263e0f" fill-rule="evenodd">'
        : ' fill="none" stroke="#263e0f" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><g>') + ic.d + '</g></svg>';
      a.insertBefore(s, label);
    });
  }

  /* Warenkorb-Design Teil 2 (Sept 2026):
     - DHL-Hinweis oben dezent (ohne grüne Fläche) mit der Hannemann-Ape – gilt für leeren und gefüllten Warenkorb.
     - Leerer Warenkorb: Kopfbereich oben, Leer-Hinweis mit Button, darunter „Brauchst du Inspiration?“.
       Produkte für „Brauchst du Inspiration?“: Liste INSPIRATION (Produkt-Handles) – einfach austauschbar. */
  var INSPIRATION = ['feather-rasierklingen', 'aftershave-balsam-alphabalm', 'alaunstein', 'einsteigerhobel-3-tlg'];
  var APE = "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 46 32'%3E%3Cg stroke='%236b4e2e' stroke-width='.7'%3E%3Crect x='4' y='7' width='8' height='6' fill='%23c9a37a'/%3E%3Crect x='11' y='3.5' width='8' height='9.5' fill='%23d6b184' transform='rotate(-6 15 8)'/%3E%3C/g%3E%3Cpath d='M4 10h8M14.5 4.5l.8 8' stroke='%232f5a1f' stroke-width='1'/%3E%3Crect x='2.5' y='13' width='22' height='9' rx='1' fill='%232f5a1f' stroke='%2316290b' stroke-width='1.1'/%3E%3Cpath d='M3.5 16h20M3.5 19h20' stroke='%2316290b' stroke-width='.5' opacity='.55'/%3E%3Cpath d='M24 23V7.5Q24 3 29 3h4.5q3.2 0 4.6 3.6L41.5 16q1.3 1.2 1.3 3.2V23z' fill='%232f5a1f' stroke='%2316290b' stroke-width='1.1' stroke-linejoin='round'/%3E%3Cpath d='M34 6h-.8v8.2h6.4z' fill='%23d7e7f1' stroke='%2316290b' stroke-width='.7' stroke-linejoin='round'/%3E%3Crect x='25.6' y='6' width='6.4' height='8.2' rx='1' fill='%231e2a17' stroke='%2316290b' stroke-width='.7'/%3E%3Cpath d='M26.3 14.2q0-3 2.9-3.2 2.9.2 2.9 3.2z' fill='%231c1c1c'/%3E%3Ccircle cx='29.2' cy='9.2' r='2.3' fill='%23e3b08c'/%3E%3Cpath d='M26.8 8.9q-.3-2.9 2.4-3 2.9-.1 2.6 2.7-.5-1.2-1.3-1.1-1 .7-2.4.3-.8.2-1.3 1.1z' fill='%232b2320'/%3E%3Cg fill='none' stroke='%238a6a3a' stroke-width='.35'%3E%3Ccircle cx='28.3' cy='9' r='.75'/%3E%3Ccircle cx='30.2' cy='9' r='.75'/%3E%3Cpath d='M29.05 9h.4'/%3E%3C/g%3E%3Cpath d='M28.2 10.5q1 .9 2 0' fill='%23fff' stroke='%236b2e1e' stroke-width='.3'/%3E%3Cpath d='M28.6 11.3q.6.4 1.2 0' stroke='%232b2320' stroke-width='.5' fill='none'/%3E%3Crect x='40.6' y='16.8' width='2.2' height='1.8' rx='.4' fill='%23f2a33a'/%3E%3Ccircle cx='40.4' cy='20' r='.9' fill='%23f5f5f0' stroke='%2316290b' stroke-width='.4'/%3E%3Cpath d='M26.5 18h5.5' stroke='%23fff' stroke-width='.8' opacity='.9'/%3E%3Cg%3E%3Ccircle cx='9.5' cy='24.5' r='3.3' fill='%23222'/%3E%3Ccircle cx='9.5' cy='24.5' r='1.2' fill='%23bbb'/%3E%3C/g%3E%3Cg%3E%3Ccircle cx='38' cy='24.5' r='3.3' fill='%23222'/%3E%3Ccircle cx='38' cy='24.5' r='1.2' fill='%23bbb'/%3E%3C/g%3E%3C/svg%3E\")";
  var CART_CSS =
    '#slidecarthq .slidecarthq > .empty{order:2;display:flex!important;flex-direction:column;padding:0!important;align-items:stretch!important}' +
    '#slidecarthq .slidecarthq > .header::after{background:' + APE + ' no-repeat left center/30px 21px!important;color:#263e0f!important;padding:3px 0 3px 38px!important;border-radius:0!important;font-size:14px!important;font-weight:600!important;line-height:21px!important}' +
    '#slidecarthq .empty .empty-cart-wrapper{display:none!important}' +
    '#slidecarthq .hn-empty{display:block!important;text-align:center;padding:22px 24px 18px!important}' +
    '#slidecarthq .hn-empty__icon{width:58px;height:58px;border-radius:50%;background:#f4f1ea;display:flex!important;align-items:center;justify-content:center;margin:0 auto 10px}' +
    '#slidecarthq .hn-empty__icon svg{width:30px!important;height:30px!important}#slidecarthq .hn-empty__icon svg path{stroke:#263e0f!important;fill:none!important}' +
    '#slidecarthq .hn-empty b{display:block;font-size:17px!important;font-weight:700!important;color:#232323!important}' +
    '#slidecarthq .hn-empty p{margin:6px 0 14px!important;font-size:13px!important;line-height:1.4!important;color:#666!important}' +
    '#slidecarthq .hn-empty__btn{display:flex!important;align-items:center;justify-content:center;height:52px;border-radius:12px;background:#263e0f!important;color:#fff!important;font-size:17px!important;font-weight:700!important;text-decoration:none!important}' +
    '#slidecarthq .hn-insp{display:block!important;border-top:1px solid #e7e2d6;background:#f4f1ea;padding:14px 20px 20px!important;flex:1;text-align:left}' +
    '#slidecarthq .hn-insp h3{margin:0 0 10px!important;font-size:15px!important;font-weight:700!important;color:#263e0f!important;text-transform:none!important;letter-spacing:0!important;text-align:left!important}' +
    '#slidecarthq .hn-insp__row{display:flex!important;flex-wrap:nowrap!important;align-items:center;gap:12px;background:#fff;border:1px solid #e7e2d6;border-radius:10px;padding:8px!important;margin:0 0 8px!important}' +
    '#slidecarthq .hn-insp__row a.hn-insp__link{display:flex!important;align-items:center;gap:12px;flex:1 1 auto;min-width:0;color:#232323!important;text-decoration:none!important}' +
    '#slidecarthq .hn-insp__row img{width:52px!important;height:52px!important;object-fit:contain;flex:0 0 52px;margin:0!important}' +
    '#slidecarthq .hn-insp__t{display:block!important;font-size:13px!important;line-height:1.3!important;text-align:left}#slidecarthq .hn-insp__t b{display:block;font-size:13px!important;font-weight:700!important}#slidecarthq .hn-insp__t span{font-size:13px!important;color:#666!important}' +
    '#slidecarthq .hn-insp__add{flex:0 0 34px;width:34px!important;height:34px!important;min-height:0!important;padding:0!important;margin:0!important;border:0!important;border-radius:50%!important;background:#263e0f!important;color:#fff!important;font-size:20px!important;line-height:1!important;cursor:pointer;display:flex!important;align-items:center;justify-content:center}' +
    '#slidecarthq .hn-insp__add[disabled]{opacity:.5}';
  var inspData = null, inspLoading = false;
  function money(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  function loadInspiration() {
    if (inspData || inspLoading) return;
    inspLoading = true;
    Promise.all(INSPIRATION.map(function (h) {
      return fetch(root + 'products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (list) {
      inspData = list.filter(Boolean).map(function (p) {
        var v = p.variants.filter(function (x) { return x.available; })[0];
        if (!v) return null;
        var img = p.featured_image || '';
        if (img.indexOf('//') === 0) img = 'https:' + img;
        return { url: p.url || ('/products/' + p.handle), title: p.title, price: v.price, id: v.id, img: img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=120' };
      }).filter(Boolean);
      inspLoading = false;
      refreshEmptyWhenLoaded();
    });
  }
  function syncEmptyCart() {
    if (!document.getElementById('hn-cart2-css')) {
      var css = document.createElement('style');
      css.id = 'hn-cart2-css';
      css.textContent = CART_CSS;
      document.head.appendChild(css);
    }
    var em = document.querySelector('#slidecarthq .slidecarthq > .empty');
    if (!em) return;
    loadInspiration();
    if (em.querySelector('.hn-empty')) return;
    var box = document.createElement('div');
    box.className = 'hn-empty-wrap';
    var rows = (inspData || []).map(function (p) {
      return '<div class="hn-insp__row"><a class="hn-insp__link" href="' + p.url + '"><img src="' + p.img + '" alt="" loading="lazy"><span class="hn-insp__t"><b>' + p.title + '</b><span>' + money(p.price) + '</span></span></a>' +
        '<button type="button" class="hn-insp__add" data-id="' + p.id + '" aria-label="' + p.title + ' in den Warenkorb">+</button></div>';
    }).join('');
    box.innerHTML =
      '<div class="hn-empty"><div class="hn-empty__icon"><svg viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="#263e0f" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 8h14l-1 13H6z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg></div>' +
      '<b>Dein Warenkorb ist noch leer</b><p>Ab 50 € versandkostenfrei – stöber dich einfach durch.</p>' +
      '<a class="hn-empty__btn" href="' + root + 'collections/all">Jetzt stöbern</a></div>' +
      (rows ? '<div class="hn-insp"><h3>Brauchst du Inspiration?</h3>' + rows + '</div>' : '');
    if (!inspData) box.dataset.pending = '1';
    em.appendChild(box);
    box.addEventListener('click', function (e) {
      var b = e.target.closest('.hn-insp__add');
      if (!b) return;
      b.disabled = true;
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: +b.dataset.id, quantity: 1 }] }) })
        .then(function () { if (typeof window.SLIDECART_UPDATE === 'function') window.SLIDECART_UPDATE(); else location.reload(); })
        .catch(function () { b.disabled = false; });
    });
  }
  function refreshEmptyWhenLoaded() {
    var pend = document.querySelector('.hn-empty-wrap[data-pending]');
    if (pend && inspData) { pend.remove(); syncEmptyCart(); }
  }

  /* Nach „In den Warenkorb“ (Sept 2026): Warenkorb öffnet sich NICHT mehr automatisch.
     Stattdessen kurzer Hinweis unten („✓ In den Warenkorb gelegt – Warenkorb ansehen“),
     das Warenkorb-Symbol oben hüpft kurz und die Zahl wird aktualisiert.
     Zurück zum alten Verhalten: AUTO_OPEN_OFF = false setzen. */
  var AUTO_OPEN_OFF = true;
  var lastAdd = 0, lastUserTap = 0, lastTapOnAdd = false, realOpen = null;
  function cartIsOpen() {
    var sc = document.querySelector('#slidecarthq .slidecarthq');
    if (!sc) return false;
    var r = sc.getBoundingClientRect();
    return r.width > 0 && r.left < window.innerWidth - 10;
  }
  function openCart() { if (realOpen) realOpen(); else if (window.SLIDECART_OPEN) window.SLIDECART_OPEN(); }
  function ensureToastCss() {
    if (document.getElementById('hn-toast-css')) return;
    var css = document.createElement('style');
    css.id = 'hn-toast-css';
    css.textContent =
      '.hn-toast{position:fixed;left:50%;bottom:18px;z-index:2147483000;transform:translate(-50%,140%);opacity:0;transition:transform .3s ease,opacity .3s ease;' +
      'display:flex;align-items:center;gap:12px;width:calc(100% - 32px);max-width:420px;box-sizing:border-box;padding:12px 16px;border-radius:12px;background:#263e0f;color:#fff;' +
      'box-shadow:0 8px 24px rgba(0,0,0,.25);font-size:14px;line-height:1.3;font-weight:600}' +
      '.hn-toast.is-in{transform:translate(-50%,0);opacity:1}' +
      '.hn-toast__ok{flex:0 0 22px;width:22px;height:22px;border-radius:50%;background:#fff;color:#263e0f;display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:700}' +
      '.hn-toast__txt{flex:1}' +
      '.hn-toast__btn{flex:0 0 auto;background:none!important;border:0!important;padding:0!important;margin:0!important;min-height:0!important;height:auto!important;width:auto!important;color:#fff!important;font:inherit!important;font-weight:700!important;text-decoration:underline!important;text-underline-offset:3px;cursor:pointer;text-transform:none!important;letter-spacing:0!important}' +
      '@keyframes hnBump{0%,100%{transform:scale(1)}30%{transform:scale(1.25)}60%{transform:scale(.92)}}' +
      '.hn-bump{animation:hnBump .6s ease}' +
      '@media (prefers-reduced-motion:reduce){.hn-toast{transition:none}.hn-bump{animation:none}}';
    document.head.appendChild(css);
  }
  var toastTimer = null;
  function showAddedToast() {
    ensureToastCss();
    var t = document.querySelector('.hn-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'hn-toast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      t.innerHTML = '<span class="hn-toast__ok" aria-hidden="true">✓</span><span class="hn-toast__txt">In den Warenkorb gelegt</span><button type="button" class="hn-toast__btn">Warenkorb ansehen</button>';
      t.querySelector('.hn-toast__btn').addEventListener('click', function () { hideToast(); openCart(); });
      document.body.appendChild(t);
    }
    clearTimeout(toastTimer);
    requestAnimationFrame(function () { t.classList.add('is-in'); });
    setTimeout(function () { t.classList.add('is-in'); }, 20);
    toastTimer = setTimeout(hideToast, 4500);
  }
  function hideToast() { var t = document.querySelector('.hn-toast'); if (t) t.classList.remove('is-in'); }
  function bumpCartIcon(count) {
    document.querySelectorAll('.header__icon--cart, .cart-count-bubble').forEach(function (el) {
      if (el.closest('#slidecarthq')) return;
      el.classList.remove('hn-bump'); void el.offsetWidth; el.classList.add('hn-bump');
    });
    if (typeof count === 'number') {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = count; });
      document.querySelectorAll('.cart-count-bubble .visually-hidden').forEach(function (el) { el.textContent = count + ' Artikel'; });
    }
  }
  function onAdded() {
    lastAdd = Date.now();
    if (!AUTO_OPEN_OFF) return;
    setTimeout(function () {
      if (cartIsOpen()) return; // z. B. „+“ im geöffneten Warenkorb: dort sieht man es direkt
      showAddedToast();
      fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); })
        .then(function (c) { bumpCartIcon(c.item_count); }).catch(function () { bumpCartIcon(); });
    }, 350);
  }
  function isAddUrl(u) { return /\/cart\/add(\.js|\.json)?(\?|$)/.test(String(u || '')); }
  (function hookRequests() {
    if (window.__hnAddHook) return;
    window.__hnAddHook = true;
    if (window.fetch) {
      var of = window.fetch;
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url);
        var p = of.apply(this, arguments);
        if (isAddUrl(url)) p.then(function (r) { if (r && r.ok) onAdded(); }).catch(function () {});
        return p;
      };
    }
    var oo = XMLHttpRequest.prototype.open, os = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__hnAdd = isAddUrl(u); return oo.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      if (this.__hnAdd) this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300) onAdded(); });
      return os.apply(this, arguments);
    };
  })();
  document.addEventListener('pointerdown', function (e) {
    lastUserTap = Date.now();
    lastTapOnAdd = !!(e.target.closest && e.target.closest('form[action*="/cart/add"], [name="add"], .hn-mm, .hn-mb, .hn-insp__add, [data-hn-add]'));
  }, true);
  function patchSlideCart() {
    if (!AUTO_OPEN_OFF) return true;
    if (typeof window.SLIDECART_STATE !== 'function' || typeof window.SLIDECART_OPEN !== 'function') return false;
    try { var st = window.SLIDECART_STATE(); if (st && st.settings) st.settings.open_on_add = false; } catch (e) {}
    if (!window.SLIDECART_OPEN.__hn) {
      realOpen = window.SLIDECART_OPEN;
      var wrapped = function () {
        var now = Date.now();
        var userOpens = now - lastUserTap < 800 && !lastTapOnAdd; // Klick auf Warenkorb-Symbol o. Ä.
        if (now - lastAdd < 3000 && !userOpens) return; // Öffnen direkt nach dem Hinzufügen unterdrücken
        return realOpen.apply(this, arguments);
      };
      wrapped.__hn = true;
      window.SLIDECART_OPEN = wrapped;
    }
    return true;
  }
  (function waitForSlideCart(n) {
    if (patchSlideCart() || n > 100) return;
    setTimeout(function () { waitForSlideCart(n + 1); }, 200);
  })(0);

  /* Produktseiten (Sept 2026): kleine Zahlungs-Icons wie im Footer direkt unter den Badges
     „60 Jahre Hannemann“ / „Kostenloser Versand“. Die Icons werden aus dem Footer übernommen
     (Liste .list-payment), sind also immer dieselben wie dort. Die alte Text-Liste
     „PayPal / Klarna / Alle Kreditkarten …“ wird dafür ausgeblendet. */
  var VORKASSE_SVG = '<svg class="icon icon--full-color" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 38 24" width="38" height="24" aria-label="Vorkasse (Banküberweisung)">' +
    '<title>Vorkasse (Banküberweisung)</title>' +
    '<rect x=".5" y=".5" width="37" height="23" rx="2.5" fill="#fff" stroke="#000" stroke-opacity=".25"/>' +
    '<text x="19" y="14.6" text-anchor="middle" font-family="Arial,Helvetica,sans-serif" font-size="6.4" font-weight="700" letter-spacing=".1" fill="#1d1d1b" textLength="31" lengthAdjust="spacingAndGlyphs">VORKASSE</text>' +
    '</svg>';

  function addPayIcons() {
    var src = document.querySelector('footer .list-payment, .footer .list-payment, .list-payment');
    if (!src) return;
    if (!document.getElementById('hn-pay-css')) {
      var css = document.createElement('style');
      css.id = 'hn-pay-css';
      css.textContent = '.hn-pay-icons{display:flex;flex-wrap:nowrap;justify-content:center;gap:5px;margin:14px 0 4px;padding:0;list-style:none}' +
        '.hn-pay-icons li{flex:0 1 34px;min-width:0;margin:0!important;padding:0!important;list-style:none;line-height:0}' +
        '.hn-pay-icons svg,.hn-pay-icons img{width:100%!important;height:auto!important;aspect-ratio:38/24;display:block}' +
        '.hn-pay-textlist{display:none!important}';
      document.head.appendChild(css);
    }
    /* Vorkasse-Icon (Banküberweisung) – im Footer und damit auch in den Kopien auf den Produktseiten */
    document.querySelectorAll('.list-payment, .hn-pay-icons').forEach(function (ul) {
      if (ul.querySelector('.hn-vorkasse')) return;
      var li = document.createElement('li');
      li.className = 'list-payment__item hn-vorkasse';
      li.innerHTML = VORKASSE_SVG;
      ul.appendChild(li);
    });
    document.querySelectorAll('.lb-atc-benefits').forEach(function (ben) {
      if (ben.closest('footer, .footer, #slidecarthq')) return;
      if (ben.nextElementSibling && ben.nextElementSibling.classList.contains('hn-pay-icons')) return;
      var ul = src.cloneNode(true);
      ul.className = 'hn-pay-icons';
      ul.setAttribute('aria-label', 'Zahlungsarten');
      ul.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
      ben.insertAdjacentElement('afterend', ul);
    });
    document.querySelectorAll('.productView-details img[alt="PayPal"]').forEach(function (img) {
      var box = img.parentElement && img.parentElement.parentElement;
      if (box && !box.classList.contains('hn-pay-textlist') && /PayPal Express/.test(box.textContent) && /Kreditkarten/.test(box.textContent)) {
        box.classList.add('hn-pay-textlist');
      }
    });
  }

  /* Warenkorb-Seite (/cart) */
  function initCartPage() {
    if (!/\/cart\/?$/.test(window.location.pathname)) return;
    var sels = ['cart-items .cart-list', '.cart-list', 'cart-items', '.cart-items', '#main-cart-items', 'form[action*="/cart"] table'];
    var target = null;
    for (var i = 0; i < sels.length && !target; i++) target = document.querySelector(sels[i]);
    if (!target || document.querySelector('.hn-clear--page')) return;
    var w = build(function () { window.location.reload(); });
    w.classList.add('hn-clear--page');
    target.insertAdjacentElement('afterend', w);
  }

  function init() {
    fixDelivery();
    fixCustomerCount();
    addNavIcons();
    addPayIcons();
    syncSlideCart();
    syncEmptyCart();
    initCartPage();
    if (window.MutationObserver) new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
